export default "<div class=\"fileUploadsList_root\">\n    <div data-dojo-attach-point=\"rowContainer\"\n         id=\"fileUploadsContainer\"></div>\n</div>\n"